// @index('./**/*.js', f => `export * from '${f.path}'`)
export * from './AboutPage'
export * from './AdminGuidePage'
export * from './ContactPage'
export * from './FaqPage'
export * from './SupportPage'
